import React, { useEffect, useState } from "react";
import { withUser } from "@coverme/identity";
import { connect } from "react-redux";
import "../styles/dashboard.scss";
import { LoadingBar } from "../components/LoadingComponents/LoadingBar";
import { Field, Formik } from "formik";
import * as formsService from "../services/formsService";
import * as Yup from "yup";
import { InputField, CTA } from "@coverme/forms";
import * as callCenterActions from "../actions/callCenterActions";
import Cookie from "js-cookie";
import { toast } from "react-toastify";
import { isCallCenterUser } from "../services/userService";

const isStateLoading = x => x.isInitialized === false || x.isLoading === true;

export const CustomerSelectionComponent = ({ user, customer, history, searchCustomerByCallCenterCode }) => {
    const isLoading = user == null || user.profile == null;
    const [searchQuery, setSearchQuery] = useState("");
    const [intervalId, setIntervalId] = useState(null);

    useEffect(() => {
        Cookie.set("cc-cus-id", null);
    }, []);

    useEffect(() => {
        if (!isCallCenterUser(user)) {
            history.push("/");
        }
    }, [customer]);

    const initialValues = {
        customerCode: "",
    };

    const onSubmit = data => {
        searchCustomerByCallCenterCode(data.customerCode).then(result => {
            if (result != null) {
                customer = result;
                Cookie.set("cc-cus-id", result.customer.GlobalId);
                return history.push(`interview/new/person`);
            } else {
                toast.error("Please enter a valid Facility Code.");
            }
        });
    };

    const searchDebounce = code => {
        searchCustomerByCallCenterCode(code);
    };

    const onSearchCustomerByCallCenterCode = e => {
        clearInterval(intervalId);
        setSearchQuery(e.target.value);
        setIntervalId(setTimeout(searchDebounce.bind(null, e.target.value), 1000));
    };

    const validationSchema = Yup.object().shape({
        customerCode: Yup.string()
            .nullable()
            .required("Required")
            .min(6, "Customer Code should be 6 or more characters."),
    });

    return (
        <div className="dashboard">
            <LoadingBar isLoading={isLoading}>
                <div className="dashboard__container">
                    <div className="dashboard__content">
                        <div className="dashboard__left">
                            <div style={{ position: "relative" }}>
                                <h2>Call Center</h2>
                                <p>
                                    Hello {user.profile.given_name}. Please enter the Facility Code below. The Facility
                                    Code has 6 or more characters
                                </p>
                                <Formik
                                    onSubmit={onSubmit}
                                    initialValues={initialValues}
                                    validationSchema={validationSchema}
                                    render={props => {
                                        const {
                                            setFieldValue,
                                            setFieldTouched,
                                            resetForm,
                                            handleSubmit,
                                            errors,
                                            touched,
                                            values,
                                        } = props;
                                        const getValidationState = formsService.getValidationState.bind(
                                            this,
                                            errors,
                                            touched
                                        );
                                        const getErrors = formsService.getErrors.bind(this, errors);
                                        return (
                                            <form id="customer-selection" className="wizard-form">
                                                <div className="form-section">
                                                    <div className="form-control m-input">
                                                        <Field
                                                            name="customerCode"
                                                            render={({ field }) => (
                                                                <InputField
                                                                    id="call_canter_customercode"
                                                                    placeholder={"Customer Code"}
                                                                    errorMessage={getErrors(field)}
                                                                    validState={getValidationState(field)}
                                                                    onChange={onSearchCustomerByCallCenterCode}
                                                                    {...field}
                                                                />
                                                            )}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="wizard-buttons">
                                                    <CTA styleType={"blue"} size={"large"} click={handleSubmit}>
                                                        Start New Case
                                                    </CTA>
                                                </div>
                                            </form>
                                        );
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </LoadingBar>
        </div>
    );
};

export const CustomerSelectionComponentWithUser = withUser(CustomerSelectionComponent);

export const CustomerSelectionContainer = connect(
    state => ({
        customer: state.callCenter,
    }),
    dispatch => ({
        searchCustomerByCallCenterCode: code => dispatch(callCenterActions.searchCustomerByCallCenterCode(code)),
    })
)(CustomerSelectionComponentWithUser);
